import styled from "styled-components";
import { Form, Input, Button } from "antd";
import { Link } from "react-router-dom";
import FormControl from "../../component/form/FormControl";
import Service from "../../service/Auth";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const FormExtend = styled(FormControl)`
  border-radius: 99px;

  .register-forgot-pwd {
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media only screen and (min-width: 1200px) {
      & > * {
        font-size: 1.2vw;
      }
    }

    @media only screen and (max-width: 768px) {
      & > * {
        font-size: 16px;
      }
    }
    @media only screen and (max-width: 450px) {
      & > * {
        font-size: 14px;
      }
    }
  }

  .form-button {
    padding-left: 0;
    padding-right: 0;
    button {
      width: 100%;
      color: white;
      background-color: #007bff;
    }

    button:hover {
      background-color: white;
      color: #007bff;
      border-radius: 5px;
      transition: 0.3s;
    }
  }
`;

export default function FormLoginUser(props) {
  const [form] = Form.useForm()

  const onFinish = async (values) => {
    let result = await Service.login(values.email, values.password)
    if (result) {
      let go = "/dashboard";
      if(!result.approve) go = "/waiting-for-approve"
      if(result.ug === 1) go = "/map" 
      window.location.href = go
    } else {
      form.setFieldsValue({ password: "" });
      setTimeout(() => {
        document.getElementById("form-login_password").focus();
      }, 300);
    }
  };

  const formInput = () => {
    return (
      <>
        <Form.Item
          name={["email"]}
          className="form-item__email"
          label="อีเมล"
          rules={[{ required: true, type: "email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={["password"]}
          className="form-item__password"
          label="รหัสผ่าน"
          rules={[{ required: true }]}
        >
          <Input.Password />
        </Form.Item>
        <div className="register-forgot-pwd">
          <Link to={"/register"}>ลงทะเบียนผู้ใช้งานใหม่</Link>
          <Link to={"/forget-password"}>ลืมรหัสผ่าน</Link>
        </div>
        <Form.Item className="form-button">
          <Button
            className="form-item__btn-submit btn-primary"
            htmlType="submit"
          >
            เข้าสู่ระบบ
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
    <FormExtend
      name={"form-login"}
      column={1}
      inputs={formInput}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      form={form}
      className={props.className ? props.className : ""}
    ></FormExtend>
  );
}
